var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2281_10090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 0.972019C4.74091 0.972019 2.08954 3.62127 2.08954 6.87777C2.08954 7.94984 2.57072 9.10285 2.59089 9.15148C2.7463 9.52007 3.05295 10.0926 3.27407 10.4282L7.32657 16.5635C7.49241 16.8151 7.73787 16.9592 8.00001 16.9592C8.26216 16.9592 8.50762 16.8151 8.67346 16.5639L12.7263 10.4282C12.9478 10.0926 13.2541 9.52007 13.4095 9.15148C13.4297 9.10319 13.9105 7.95018 13.9105 6.87777C13.9105 3.62127 11.2591 0.972019 8.00001 0.972019ZM12.7684 8.8819C12.6297 9.21228 12.3442 9.74484 12.1457 10.0457L8.09284 16.1814C8.01288 16.3026 7.9875 16.3026 7.90753 16.1814L3.85468 10.0457C3.65616 9.74484 3.37072 9.21193 3.232 8.88155C3.22609 8.86731 2.78489 7.80601 2.78489 6.87777C2.78489 4.00445 5.12439 1.66681 8.00001 1.66681C10.8756 1.66681 13.2151 4.00445 13.2151 6.87777C13.2151 7.8074 12.7729 8.87148 12.7684 8.8819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 3.75154C6.27447 3.75154 4.87091 5.15433 4.87091 6.87812C4.87091 8.6019 6.27447 10.0047 7.99998 10.0047C9.7255 10.0047 11.1291 8.6019 11.1291 6.87812C11.1291 5.15433 9.7255 3.75154 7.99998 3.75154ZM7.99998 9.30989C6.65831 9.30989 5.56626 8.21907 5.56626 6.87812C5.56626 5.53716 6.65831 4.44634 7.99998 4.44634C9.34166 4.44634 10.4337 5.53716 10.4337 6.87812C10.4337 8.21907 9.34166 9.30989 7.99998 9.30989Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2281_10090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.9872,
    fill: "white",
    transform: "translate(0 0.972019)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/Locationicon.51d00c0a4bd36d1faebd5f690c7b5f92.svg";
export { ForwardRef as ReactComponent };